/**
 * androidFileShare.js — MADDE 8
 *
 * SORUN
 * -----
 * Android'de "İndir" butonları dosyayı yalnızca tarayıcıda AÇIYORDU; yani
 * "Görüntüle" ile aynı sonucu veriyor, kullanıcı dosyayı Dosyalar'a veya
 * galeriye kaydedemiyordu.
 *
 * Denenen ve YETERSİZ kalan yollar:
 *   • <a download>            → Android WebView'de indirmeyi hiç başlatmaz.
 *   • window.open(url)        → dosyayı tarayıcıda gösterir, kaydetmez.
 *   • navigator.share(files)  → Capacitor Android WebView'de canShare({files})
 *                               çoğu cihazda false döner; bu yol devreye girmez.
 *
 * ÇÖZÜM
 * -----
 * Dosya, uygulamanın KENDİ önbellek dizinine yazılır ve Android'in yerleşik
 * PAYLAŞ/KAYDET sayfası açılır. Bu sayfa "Dosyalara kaydet", "Drive'a yükle",
 * "Fotoğraflar'a kaydet", "WhatsApp ile gönder" gibi seçenekleri sunar —
 * iOS'taki paylaşım sayfasının Android karşılığıdır.
 *
 * GOOGLE PLAY UYUMU
 * -----------------
 * Yazma işlemi Directory.Cache (uygulamaya özel önbellek) içine yapılır:
 *   • Hiçbir depolama izni GEREKTİRMEZ (READ/WRITE_EXTERNAL_STORAGE yok,
 *     MANAGE_EXTERNAL_STORAGE kesinlikle yok).
 *   • Scoped Storage kurallarına tam uyumludur.
 *   • Dosya paylaşımı, Capacitor'ın manifest'te zaten tanımlı olan
 *     FileProvider'ı üzerinden güvenli URI ile yapılır.
 * Bu nedenle ek izin beyanı doğmaz ve Play incelemesinde risk oluşturmaz.
 *
 * PLATFORM
 * --------
 * Bu yardımcı YALNIZCA Android için kullanılır. iOS kendi native köprüsünü
 * (aileNativeBridge → shareFile), web ise <a download> / navigator.share
 * yolunu kullanmaya devam eder; o akışlara dokunulmaz.
 */

import { Filesystem, Directory } from "@capacitor/filesystem";
import { Share } from "@capacitor/share";

/** Blob → base64 (data: öneki olmadan) */
function blobToBase64Raw(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error("Dosya okunamadı."));
    reader.onload = () => {
      const result = String(reader.result || "");
      const comma = result.indexOf(",");
      resolve(comma >= 0 ? result.slice(comma + 1) : result);
    };
    reader.readAsDataURL(blob);
  });
}

/** Dosya adını Android dosya sistemi için güvenli hale getirir. */
function guvenliDosyaAdi(name, fallback = "dosya") {
  const temiz = String(name || "")
    .replace(/[/\\?%*:|"<>]/g, "-")
    .replace(/\s+/g, " ")
    .trim();
  return temiz || fallback;
}

/**
 * Dosyayı önbelleğe yazıp Android paylaş/kaydet sayfasını açar.
 *
 * @param {Blob}   blob     İndirilmiş dosya içeriği
 * @param {string} fileName Kullanıcıya gösterilecek dosya adı (uzantılı)
 * @param {string} title    Paylaşım başlığı (opsiyonel)
 * @returns {Promise<boolean>} Paylaşım sayfası açıldıysa true
 */
export async function androidDosyaPaylas(blob, fileName, title = "") {
  if (!blob) return false;

  const adi = guvenliDosyaAdi(fileName);
  // Aynı adlı eski dosyaların çakışmaması için benzersiz bir klasör kullanılır.
  const yol = `paylasim/${Date.now()}-${adi}`;

  try {
    const base64 = await blobToBase64Raw(blob);

    await Filesystem.writeFile({
      path: yol,
      data: base64,
      directory: Directory.Cache,
      recursive: true,
    });

    const { uri } = await Filesystem.getUri({
      path: yol,
      directory: Directory.Cache,
    });

    await Share.share({
      title: title || adi,
      // dialogTitle → Android paylaşım sayfasının başlığı
      dialogTitle: title || adi,
      files: [uri],
    });

    return true;
  } catch (err) {
    // Kullanıcı paylaşım sayfasını kapattıysa bu bir hata değildir;
    // çağıran tarafın kullanıcıya hata göstermemesi için ayırt ediyoruz.
    const mesaj = String(err?.message || err || "").toLowerCase();
    if (mesaj.includes("cancel") || mesaj.includes("abort") || mesaj.includes("dismiss")) {
      return true;
    }
    console.warn("[androidDosyaPaylas] başarısız:", err?.message || err);
    return false;
  }
}
